<app-page-title title="Membro"></app-page-title>
<div class="member">
  <div class="profile-image-container">
    <img *ngIf="profileImage" [src]="profileImage" id="profile-image" />
    <img *ngIf="!profileImage" src="../../../assets/icons/default-user-icon-profile.png" id="profile-image" />
  </div>

  <br />
  <br />
  <div class="name">
    <h3>{{ member?.name }}({{ member?.gender }})</h3>
    <br />
  </div>

  <div class="info">
    <p><b>CEC-ID: </b>{{ member?.cec_id }}</p>

    <!-- <img src="../../../assets/icons/whatsapp.png" width="20" height="20" /> -->
  </div>
  <div class="info">
    <img src="../../../assets/icons/phone.svg" sizes=" 15" />
    <p>{{ member?.phone_number || 'não informado' }}</p>
    <!-- <img src="../../../assets/icons/whatsapp.png" width="20" height="20" /> -->
  </div>

  <div class="info">
    <img src="../../../assets/icons/email.svg" sizes=" 15" />
    <p>{{ member?.email || 'não informado' }}</p>
  </div>

  <div class="info" *ngIf="member?.city?.name && member?.state?.UF">
    <img src="../../../assets/icons/localization.svg" sizes=" 15" />
    <p>{{ member?.city?.name }}- {{ member?.state?.UF }}</p>
  </div>

  <div class="info">
    <img src="../../../assets/icons/map.svg" sizes=" 15" />
    <p>{{ member?.street }}'Nº' {{ member?.home_number }},{{ member?.complement }}</p>
  </div>

  <div class="info">
    <img src="../../../assets/icons/groups_black.svg" sizes=" 15" />
    <p>{{ member?.group?.name || 'não informado' }}</p>
  </div>

  <div class="info">
    <img src="../../../assets/icons/groups_black.svg" sizes=" 15" />
    <p>Status: {{ getChurchStatusDisplay(member?.church_status) }}</p>
  </div>

  <div class="info">
    <img src="../../../assets/icons/bloodtype_black.svg" sizes=" 15" />
    <p>{{ member?.blood_type || 'não informado' }}</p>
  </div>
</div>
